module.exports = __webpack_public_path__ + "static/img/feedback-manual.8e2d6093.png";